import { render, staticRenderFns } from "./MediakitNewCard.vue?vue&type=template&id=afc6b2e0&"
import script from "./MediakitNewCard.vue?vue&type=script&lang=js&"
export * from "./MediakitNewCard.vue?vue&type=script&lang=js&"
import style0 from "./MediakitNewCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports